module.exports = __webpack_public_path__ + "media/img/home/img_my-a266d06bc72a41399bad0a3d9a17b87e.png";